import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InteractivityOptionsComponent } from './interactivity-options/interactivity-options';
import { EnableNotificationsComponent } from './enable-notifications/enable-notifications';
import { IonicModule } from 'ionic-angular';
import { LoadingComponent } from './loading/loading';
import { PipesModule } from '../pipes/pipes.module';
import { PollPageModule } from '../pages/poll/poll.module';
import { PollEventPageModule } from '../pages/poll-event/poll-event.module';
import { MessagesEventPageModule } from '../pages/messages-event/messages-event.module'
import { MessagesPageModule } from '../pages/messages/messages.module';
import { NoStateComponent } from './no-state/no-state';
import { TranslateModule } from '@ngx-translate/core';
import { VotingPageModule } from '../pages/voting/voting.module';
import { CartItemComponent } from './cart-item/cart-item.component';
import { CardFormComponent } from './card-form/card-form.component';
import { ModalHomeScreenComponent } from './modal-home-screen/modal-home-screen';
import { ModalHomeSreenSafariComponent } from './modal-home-sreen-safari/modal-home-sreen-safari';
import { ReviewsProductComponent } from './reviews-product/reviews-product';
import { Ionic2RatingModule } from 'ionic2-rating';
import { ModalHelpSwipeComponent } from './modal-help-swipe/modal-help-swipe';
import { ButtonShoppingCartComponent } from './button-shopping-cart/button-shopping-cart';
import { ControlQuantityProductComponent } from './control-quantity-product/control-quantity-product';
import { CustomFabMenuComponent } from './custom-fab-menu/custom-fab-menu';
import { ScriptConvertComponent } from './script-convert/script-convert';
import { PayButtonShoppingComponent } from './pay-button-shopping/pay-button-shopping.component';
import { PayButtonReserveComponent } from './pay-button-reserve/pay-button-reserve.component';
import { PayButtonTicketComponent } from './pay-button-ticket/pay-button-ticket.component';
import { DirectivesModule } from '../directives/directives.module';
import { NotFoundComponent } from './not-found/not-found';
import { ProgressBarComponent } from './progress-bar/progress-bar';
import { CountoModule } from 'angular2-counto';
import { WelcomeEventUserComponent } from './welcome-event-user/welcome-event-user';
import { ControlQuantityTicketsComponent } from './control-quantity-tickets/control-quantity-tickets';
import { CartTicketItemComponent } from './cart-ticket-item/cart-ticket-item.component';
import { ButtonShoppingCartTicketComponent } from './button-shopping-cart-ticket/button-shopping-cart-ticket';
import { DetailShoppingCartHelperComponent } from './detail-shopping-cart-helper/detail-shopping-cart-helper';
import { PayButtonShoppingReserveComponent } from './pay-button-shopping-reserve/pay-button-shopping-reserve';
import { CartReserveItemComponent } from './cart-reserve-item/cart-reserve-item';
import { HelperBtnSlackComponent } from './helper-btn-slack/helper-btn-slack';
import { OnboardingReserveComponent } from './onboarding-reserve/onboarding-reserve';
import { PayButtonShoppingCartServicesComponent } from './pay-button-shopping-cart-services/pay-button-shopping-cart-services';

export const COMPONENTS = [
  InteractivityOptionsComponent,
  EnableNotificationsComponent,
  LoadingComponent,
  NoStateComponent,
  CartItemComponent,
  CardFormComponent,
  ModalHomeScreenComponent,
  ModalHomeSreenSafariComponent,
  ReviewsProductComponent,
  ModalHelpSwipeComponent,
  ModalHomeScreenComponent,
  ModalHomeSreenSafariComponent,
  ReviewsProductComponent,
  ButtonShoppingCartComponent,
  ControlQuantityProductComponent,
  CustomFabMenuComponent,
  ScriptConvertComponent,
  PayButtonShoppingComponent,
  PayButtonReserveComponent,
  PayButtonTicketComponent,
  NotFoundComponent,
  ProgressBarComponent,
  ControlQuantityTicketsComponent,
  WelcomeEventUserComponent,
  CartTicketItemComponent,
  ButtonShoppingCartTicketComponent
]
@NgModule({
  declarations: [...COMPONENTS,
    DetailShoppingCartHelperComponent,
    PayButtonShoppingReserveComponent,
    CartReserveItemComponent,
    HelperBtnSlackComponent,
    OnboardingReserveComponent,
    PayButtonShoppingCartServicesComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    DirectivesModule,
    TranslateModule,
    PipesModule,
    PollPageModule,
    PollEventPageModule,
    TranslateModule,
    MessagesEventPageModule,
    MessagesPageModule,
    VotingPageModule,
    Ionic2RatingModule,
    CountoModule,
  ],
  exports: [...COMPONENTS,
    DetailShoppingCartHelperComponent,
    PayButtonShoppingReserveComponent,
    CartReserveItemComponent,
    HelperBtnSlackComponent,
    OnboardingReserveComponent,
    PayButtonShoppingCartServicesComponent,
  ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts